<template>
    <ui-input-base-text
        v-bind:formatter="formatDown"
        v-bind:is-invalid="isInvalid"
        v-bind="formattedModel"
        v-bind:type="'tel'"
        v-on:input="inputHandler"
        v-on:focus="focusHandler"
        v-on:blur="blurHandler"
        inputmode="numeric"
        pattern="\\d*"
    />
</template>

<script>
import utils from '~/utils';

export default {
    name: 'ui-input-numeric',
    props: {
        model: {
            type: Object,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [ String, Number ],
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    computed: {
        formattedModel() {
            return { ...this.model, value: this.formatDown(this.model.value) };
        },
    },
    methods: {
        formatDown(value) {
            let result = typeof value === 'number' ? value.toString() : value;
            if (!result) {
                return '';
            }
            if (this.model.firstZeroInavailable && result[0] === '0') {
                result = result.substring(1);
            }

            result = result.replace(/[^0-9]/g, '');

            if (this.model.maxLength) {
                result = result.substring(0, this.model.maxLength);
            }
            if (this.model.maxValue && parseInt(result, 10) > this.model.maxValue) {
                result = this.model.maxValue.toString();
            }
            if (this.model.isSeparatorNeeded) {
                return utils.formats.formatNumberWithSpaces(result);
            }
            return result;
        },
        formatUp(value) {
            return value.replace(/[^0-9]/g, '');
        },
        inputHandler(newValue) {
            this.$emit('input', this.formatUp(newValue));
        },
        focusHandler(data) {
            this.$emit('focus', data);
        },
        blurHandler(data) {
            this.$emit('blur', data);
        },
    },
    watch: {
        'model.maxLength'() {
            if (this.value) {
                this.inputHandler(this.formatDown(this.value));
            }
        },
    },
    mounted() {
        if (this.value?.toString() !== this.formatUp(this.formattedModel.value)) {
            this.$emit('input', this.formatUp(this.formattedModel.value));
        }
    },
};
</script>

<style scoped lang="less">
@import "~theme";
</style>
